import React from 'react';
import cn from 'clsx';
import { SectionSubTitle, Typography } from 'common/components';
import { createElementKey } from 'utils';
import { ADVANTAGES_LIST } from './advantages-section-constants';
import {
  advantageContainer,
  advantageDescription,
  advantageImage,
  advantageName,
  advantagesSection,
} from './advantages-section-styles';

/**
 * Вью секции с преимуцествами проектирования инженерных систем в Лемана ПРО
 */
export const AdvantagesSection = () => (
  <section className={advantagesSection}>
    {ADVANTAGES_LIST.map(({ src, title, titleStyle, description }, index: number) => (
      <div key={createElementKey('advantage', index)} className={advantageContainer}>
        <img className={advantageImage} src={src} alt={title} title={title} />
        <div>
          <SectionSubTitle as="p" variant="h3" className={cn(advantageName, titleStyle)} margin="s">
            {title}
          </SectionSubTitle>
          <Typography className={advantageDescription} variant="m" size="body_short">
            {description}
          </Typography>
        </div>
      </div>
    ))}
  </section>
);
